var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewPageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.46,
    height: 16.46,
    viewBox: "0 0 17.46 16.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View",
    transform: "translate(12549.73 21002.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View_page",
    "data-name": "View page",
    transform: "translate(-12549.73 -21002.73)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1462",
    "data-name": "Rectangle 1462",
    width: 16,
    height: 15,
    rx: 1.22,
    transform: "translate(0.73 0.73)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M.73,4.73h0Z",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1463",
    "data-name": "Rectangle 1463",
    width: 1,
    height: 1,
    rx: 0.2,
    transform: "translate(2.73 2.23)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1464",
    "data-name": "Rectangle 1464",
    width: 1,
    height: 1,
    rx: 0.2,
    transform: "translate(4.73 2.23)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4667",
    "data-name": "Group 4667",
    transform: "translate(0.492 0.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M3.31,9.7S4.921,6.48,7.738,6.48,12.166,9.7,12.166,9.7s-1.611,3.222-4.428,3.222S3.31,9.7,3.31,9.7Z",
    transform: "translate(0.5)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 1.206,
    cy: 1.206,
    r: 1.206,
    transform: "translate(7.042 8.497)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPageIcon);
export default __webpack_public_path__ + "static/media/view-page-icon.42c205f0aaa4811645f8232ed72e34b1.svg";
export { ForwardRef as ReactComponent };